import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SharedModule } from '../../../shared/shared.module';
import { AdministratorService } from '../../../services/administrator.service';
import { LoaderComponent } from '../../loader/loader.component';

@Component({
  selector: 'app-create-quick-payment-terms-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule, LoaderComponent],
  templateUrl: './create-quick-payment-terms-lookup.component.html',
  styleUrl: './create-quick-payment-terms-lookup.component.scss'
})
export class CreateQuickPaymentTermsLookupComponent implements OnInit {
  @Output() PaymentTermsId = new EventEmitter<any>();

  constructor(
    private paymentTermsService: AdministratorService,
    private messageService: MessageService
  ) { }

  paymentTermsForm = new FormGroup({
    termsCode: new FormControl('', Validators.required),
    discount: new FormControl('', Validators.required),
    conditionalDiscount: new FormControl('', Validators.required),
    netDue: new FormControl('', Validators.required),
    paymentTermsDescription: new FormControl('', Validators.required),
    isActive: new FormControl(true, Validators.requiredTrue),
    createdBy: new FormControl(''),
  });

  submitted: boolean = false;
  loader: boolean = false;

  ngOnInit(): void {
    this.paymentTermsForm.controls.createdBy.setValue(localStorage.getItem('username'));
  }

  get formControls() {
    return this.paymentTermsForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.paymentTermsForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' });
      isValid = false;
    }
    return isValid;
  }

  createPaymentTerms(data: any) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    data.conditionalDiscount = data.conditionalDiscount.toString();
    data.netDue = data.netDue.toString();

    this.loader = true;
    this.paymentTermsService.createPaymentTerms(data).subscribe({
      next: (response: any) => {
        this.loader = false;
        if (response.success === true) {
          this.PaymentTermsId.emit({
            paymentTermsId: response.id,
            paymentTermsDescription: data.paymentTermsDescription,
            termsCode: data.termsCode
          });
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Payment terms created successfully.' });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: response.message });
        }
      },
      error: error => {
        this.loader = false;
        console.error('Error creating payment terms:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while creating the payment terms. Please try again later.' });
      }
    });
  }

  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.moveToNextField(event);
    }
  }

  moveToNextField(event: KeyboardEvent) {
    const inputs = Array.from(document.querySelectorAll('input')) as HTMLInputElement[];
    const index = inputs.indexOf(event.target as HTMLInputElement);
    if (index > -1 && index < inputs.length - 1) {
      (inputs[index + 1] as HTMLInputElement).focus();
    }
  }
}

